<template>
  <div class="component__collapsible">
    <h3
      @click="toggle"
      @keydown.enter="toggle"
      @keydown.space.prevent="toggle"
      class="mb-0"
      role="button"
      :class="{
        'd-flex align-item-center justify-content-between': !isDisabled,
        active: isActive,
        'toggle--disabled': isDisabled,
      }"
      :aria-expanded="!isDisabled ? (isActive ? 'true' : 'false') : null"
      :aria-controls="!isDisabled ? `collapsible-content-${_uid}` : null"
    >
      <template v-if="img">
        <img :src="img" alt="">
      </template>
      <div><strong><slot name="title"></slot></strong></div>
      <!-- <div class="toggle text-lowercase" v-if="!isDisabled">
        <span class="toggle_text" v-if="showToggleDescription">
          {{ isActive ? "Hide" : "Show" }}
        </span>
        <span class="toggle__icon"></span>
      </div> -->
      <div class="toggle" aria-hidden="true">
        <svg
          class="toggle__icon"
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 13 13"
          focusable="false"
        >
          <rect class="toggle__icon-bar toggle__icon-bar--h" x="2" y="6" width="9" height="1" fill="currentColor" />
          <g
            class="toggle__icon-bar toggle__icon-bar--v"
            :class="{ 'toggle__icon-bar--v-collapsed': isActive }"
          >
            <rect x="6" y="2" width="1" height="9" fill="currentColor" />
          </g>
        </svg>
      </div>
    </h3>
    <collapse-transition>
      <div
        v-show="isActive || isDisabled"
        :id="'collapsible-content-' + _uid"
        class="accordion__description"
      >
        <div class="accordion__description-inner" :key="`inner-${_uid}`">
          <slot></slot>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
/*
* Collapsible Vue component
* ---
* Example usage:
*
* <collapsible>
* <template v-slot:title>Accordion Title</template>
* <template>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</template>
* </collapsible>
* * <collapsible show-toggle-description="true"> will show Show/Hide text
* <collapsible :is-disabled="$mq > 2">  will disable (automatically show the contents) above VueMq breakpoint 2
*/

import {CollapseTransition} from 'vue2-transitions';

export default {
    components: {
        CollapseTransition
    },

    props: ["showToggleDescription", "isDisabled", "img", 'active'],

    data: function () {
        return {
            isActive: this.active
        }
    },        

    methods: {
        toggle: function () {
            if (this.isDisabled) return;
            const wasActive = this.isActive;
            this.isActive = !this.isActive;
        },

        close: function () {
            if (this.isDisabled) return;
            this.isActive = false;
        },
        
        open: function () {
            if (this.isDisabled) return;
            this.isActive = true;
        }
    },

    created() {
        if (this.isDisabled) {
            this.isActive = true;
        }
    }
}
</script>

<style lang="scss" scoped>
h3 {
    cursor: pointer;
    font-size: 11px;
    border-bottom: 1px solid #7c7c7c;
    padding: 15px 0;

    &.active {
      border-bottom: 0;
      // pointer-events: none;
    }

}

.toggle {
    position: relative;
    padding-right: 20px;
    color: #7c7c7c;

    &__icon {
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        width: 13px;
        height: 13px;
        color: #000;
        background-image: none;
    }

    &__icon-bar--v {
        transform-origin: center;
        transform-box: fill-box;
        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &__icon-bar--v.toggle__icon-bar--v-collapsed {
        transform: rotate(90deg);
    }

    @media (prefers-reduced-motion: reduce) {
        &__icon-bar--v {
            transition: none;
        }
    }
}

.accordion__description {
    overflow: hidden;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.accordion__description-inner {
    display: flow-root;
    padding: 15px 0;
    min-height: 0;
    transform: translateZ(0);
    backface-visibility: hidden;
}

</style>
